import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions, GridSizeChangedEvent } from 'ag-grid-community';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { MarketplaceProduct } from 'src/app/gamification/command-center/models/marketplace-product.model';
import { CvNumberLocalizePipe } from '../../../../../../reusables/pipes/cv-number-localize.pipe';

@Component({
    selector: 'cv-marketplace-products-modal',
    templateUrl: './marketplace-products-modal.component.html',
    styleUrls: ['./marketplace-products-modal.component.scss']
})
export class MarketplaceProductsModalComponent implements OnInit {
    @Input() items: any[] = [];

    gridProducts: GridOptions;
    columnLocalization = new Map();

    constructor(
        public activeModal: NgbActiveModal,
        private agGridHelperService: AgGridHelperService,
        private cvNumberLocalizePipe: CvNumberLocalizePipe,
        private cvLocalizationService: CVLocalizationService
    ) { }

    ngOnInit(): void {
        this.loadLocalization();
    }

    loadLocalization(): void {
        this.cvLocalizationService.GetSection("Order_Management").then((map) => {
            this.columnLocalization = map;
            this.setupGrid();
        });
    }

    setupGrid(): void {
        this.gridProducts = {
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                cellStyle: {
                    'line-height': '64px',
                },
            },

            accentedSort: true,
            animateRows: true,
            rowHeight: 64,
            suppressCellFocus: true,
            suppressDragLeaveHidesColumns: true,
            suppressScrollOnNewData: true,

            columnDefs: [{
                field: 'Title',
                headerName: this.getColumnName('Product', 'Product'),
                lockVisible: true,
                cellRenderer: (params) =>
                    `<img class="rounded-circle mr-2" src="../Admin/ImageResizer.aspx?imgid=${params.data.ProductImageID}&w=64&h=64" onerror="this.src='../Admin/ImageResizer.aspx?imgid=-15&w=64&h=64'" style="width: 32px;"> ${params.value}`,
                minWidth: 200
            }, {
                field: 'Description',
                headerName: this.getColumnName('Description', 'Description'),
                minWidth: 260
            }, {
                field: 'Price',
                headerName: this.getColumnName('Price', 'Price'),
                cellRenderer: (params) => this.cvNumberLocalizePipe.transform(params.value),
                minWidth: 125
            }, {
                field: 'TotalQty',
                headerName: this.getColumnName('Quantity', 'Quantity'),
                cellRenderer: (params) => this.cvNumberLocalizePipe.transform(params.value),
                minWidth: 125
            }, {
                field: 'QuantityOrdered',
                headerName: this.getColumnName('Quantity_Ordered', 'Quantity Sold'),
                cellRenderer: (params) => this.cvNumberLocalizePipe.transform(params.value),
                minWidth: 200
            }],

            rowData: null,
            getLocaleText: this.agGridHelperService.getLocaleText,
            overlayLoadingTemplate: '<div class="loadView mt-5"></div>',

            getRowId: ({data: product}) => String(product.PointStoreProductID),

            onGridReady: (e) => {
                e.api.showLoadingOverlay();
                e.api.setGridOption('rowData', this.items);
                e.columnApi.autoSizeAllColumns();
            },

            onGridSizeChanged: (e: GridSizeChangedEvent) => {
                e.api.sizeColumnsToFit();
            }
        };
    }

    getColumnName(key: string, defaultValue: string): string {
        if (this.columnLocalization && this.columnLocalization.has(key))
            return this.columnLocalization.get(key);
        else
            return defaultValue;
    }

    closeModal(): void {
        this.activeModal.close();
    }
}
